<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-5">
        <div class="card shadow-sm">
          <div class="card-body p-4">
            <h2 class="card-title text-center mb-1">Crear cuenta</h2>
            <p class="text-muted text-center mb-4 small">Has sido invitado a Vida</p>

            <div v-if="tokenInvalido" class="alert alert-danger">
              <i class="bi bi-exclamation-triangle me-2"></i>
              El enlace de invitación es inválido o ha expirado. Solicita una nueva invitación al administrador.
            </div>

            <div v-if="exito" class="alert alert-success">
              <i class="bi bi-check-circle me-2"></i>
              Cuenta creada correctamente. Redirigiendo...
            </div>

            <div v-if="error" class="alert alert-danger">{{ error }}</div>

            <form v-if="!tokenInvalido && !exito" @submit.prevent="handleSubmit">
              <div class="mb-3">
                <label class="form-label">Email</label>
                <input
                  type="email"
                  class="form-control"
                  :value="email"
                  readonly
                  disabled
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Nombre</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="nombre"
                  placeholder="Tu nombre"
                  required
                  autofocus
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="password"
                  minlength="6"
                  placeholder="Mínimo 6 caracteres"
                  required
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Confirmar contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': password && confirmPassword && password !== confirmPassword }"
                  v-model="confirmPassword"
                  required
                />
                <div class="invalid-feedback">Las contraseñas no coinciden</div>
              </div>
              <div class="d-grid">
                <button
                  type="submit"
                  class="btn btn-success"
                  :disabled="loading || (password && confirmPassword && password !== confirmPassword)"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  {{ loading ? 'Creando cuenta...' : 'Crear mi cuenta' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import axios from '../config/axios';

export default {
  name: 'RegistroView',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const token = ref('');
    const email = ref('');
    const nombre = ref('');
    const password = ref('');
    const confirmPassword = ref('');
    const loading = ref(false);
    const exito = ref(false);
    const error = ref('');
    const tokenInvalido = ref(false);

    onMounted(async () => {
      token.value = route.query.token || '';
      if (!token.value) {
        tokenInvalido.value = true;
        return;
      }
      try {
        const res = await axios.get(`/api/auth/verificar-invitacion?token=${token.value}`);
        email.value = res.data.email;
      } catch {
        tokenInvalido.value = true;
      }
    });

    const handleSubmit = async () => {
      if (password.value !== confirmPassword.value) {
        error.value = 'Las contraseñas no coinciden';
        return;
      }
      loading.value = true;
      error.value = '';
      try {
        const res = await axios.post('/api/auth/register', {
          nombre: nombre.value,
          email: email.value,
          password: password.value,
          token: token.value
        });
        // Login automático tras registro
        await store.dispatch('auth/setAuth', res.data);
        exito.value = true;
        setTimeout(() => router.push('/'), 1500);
      } catch (err) {
        error.value = err.response?.data?.error || 'Error al crear la cuenta. Inténtalo de nuevo.';
      } finally {
        loading.value = false;
      }
    };

    return { token, email, nombre, password, confirmPassword, loading, exito, error, tokenInvalido, handleSubmit };
  }
};
</script>
